import { extendZodWithOpenApi } from '@anatine/zod-openapi';
import { z } from 'zod';

extendZodWithOpenApi(z);

export const EmbeddedThingLightSchema = z.object({
  id: z.number().int().openapi({ description: 'Bucket ID', example: 1 }),
  title: z
    .string()
    .openapi({ description: 'Bucket title', example: 'Some Pull Request Title Here' }),
  icon_url: z
    .string()
    .nullable()
    .openapi({ description: 'Bucket icon URL', example: 'https://...' }),
});

/**
 * Create Things via minimal definitions, used for Memories atm
 * @todo Revisit when we have a proper Thing model in Zod
 */
export const CreateThingLightSchema = z.object({
  uri: z
    .string()
    .url()
    .openapi({ description: 'Thing URI', example: 'https://api.github.com/Timely/app/issues/1' }),
  title: z
    .string()
    .optional()
    .nullable()
    .openapi({ description: 'Thing title', example: 'Some Issue Title Here' }),
  icon_url: z
    .string()
    .nullable()
    .optional()
    .openapi({ description: 'Thing icon URL', example: 'https://...' }),
  /** @todo Hook this into the real "types" of the db */
  type: z
    .string()
    .optional()
    .nullable()
    .openapi({ description: 'Thing type', example: 'pull_request' }),
});
